import { Button } from "shared/ui/button";
import VenueBuilding from "../assets/VenueBuilding.png";
import VenueRoom from "../assets/VenueRoom.png";
import MapPin from "shared/assets/images/Map_pin.svg";
import styles from "./EventVenueSection.module.scss";

export const EventVenueSection = () => {
  return (
    <div className={styles.venueSection}>
      <p className={styles.venueSection__title}>Место проведения</p>
      <div className={styles.venueSection__imgBlock}>
        <img
          src={VenueBuilding}
          className={styles.venueSection__img}
          alt="VenueBuilding"
        />
        <img
          src={VenueRoom}
          className={styles.venueSection__img}
          alt="VenueRoom"
        />
      </div>
      <div className={styles.venueSection__bottomBlock}>
        <div className={styles.venueSection__adressBlock}>
          <img
            src={MapPin}
            className={styles.venueSection__adressIcon}
            alt="MapPin"
          />
          <p className={styles.venueSection__adressText}>
            г. Самара, Отель Реальянс, ул. Ново-Садовая, 162 В
          </p>
        </div>
        <div className={styles.venueSection__button}>
          <Button
            variant="primary"
            size="large"
            onClick={() =>
              window.open(
                "https://yandex.ru/maps/org/realyans/1089695301/?ll=50.178716,53.231254&z=17&pt=50.178716,53.231254",
                "_blank",
              )
            }
          >
            Показать на карте
          </Button>
        </div>
      </div>
    </div>
  );
};
